
























import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "MeterReadingError",
  props: {
    showError: {
      type: Boolean,
      default: false,
    },
  },
});
